import { Injectable } from '@angular/core';
import {AppSettings} from '../../../settings/app-settings';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {TGrn} from '../model/t-grn';

@Injectable()
export class TGrnService {

  constructor(private http: HttpClient) {
  }

  public findByTransactionNumber(tNumber: number): Observable<TGrn> {
    return this.http.get<TGrn>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/t-grn/find-by-t-number/" + tNumber);
  }

  public save(tGrn: TGrn): Observable<TGrn> {
    return this.http.post<TGrn>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/t-grn/save", tGrn);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-grn/service/t-grn.service.ts